import React from 'react';

const BagIcon = ({ ...props }) => {
  return (
    <svg
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M29.2916 9.25H7.70825C5.15394 9.25 3.08325 11.3207 3.08325 13.875V18.0697L13.6242 21.5833H23.3756L33.9166 18.0697V13.875C33.9166 11.3207 31.8459 9.25 29.2916 9.25Z"
        fill="#C3E8F1"
      />
      <path
        d="M15.4166 9.25V7.70833H21.5833V9.25H24.6666V7.70833C24.6646 6.00626 23.2853 4.62694 21.5833 4.625H15.4166C13.7145 4.62694 12.3352 6.00626 12.3333 7.70833V9.25H15.4166ZM13.6242 21.5833L3.08325 18.0696V27.75C3.08604 30.3032 5.15508 32.3722 7.70825 32.375H29.2916C31.8448 32.3722 33.9138 30.3032 33.9166 27.75V18.0696L23.3756 21.5833H13.6242Z"
        fill="#027794"
      />
    </svg>
  );
};

export default BagIcon;
